<template>
  <h2 v-if="level == 'h2'" class="c-title c-title--h02">
    <Icon v-if="icon" :variant="icon" :size="22" radius />
    <slot></slot>
  </h2>
  <h3 v-else-if="level == 'h3'" class="c-title c-title--h03">
    <Icon v-if="icon" :variant="icon" :size="22" radius />
    <slot></slot>
  </h3>
  <h4 v-else-if="level == 'h4'" class="c-title c-title--h04"><slot></slot></h4>
</template>
<script>
import Icon from '@/components/Icon';
export default {
  components: {
    Icon
  },
  props: {
    icon: {
      type: String,
      required: false
    },
    level: {
      type: String,
      required: false
    }
  }
};
</script>
